import React from "react";
import { Pie } from "@ant-design/charts";
import { getReadableValue } from "../../../../../../helpers";

export function TecRelationshipChart({ odes = [] }) {
  const accumulate = (key, object) => {
    if(key) {
      if(Object.prototype.hasOwnProperty.call(object, key)) {
        object[key]++;
      }
      else {
        object[key] = 1;
      }
    }
    else {
      object["No especificado"]++;
    }

    return object;
  };

  const relationships = odes.reduce((acc, ode) => {
    ode.team.forEach(user => {
      if(user.tecRelationships.length) {
        user.tecRelationships.forEach(tecRelationship => {
          const relationship = tecRelationship.type;
          accumulate(relationship, acc);
        });
      }
      else if(user.tecRelationship && user.tecRelationship.length) {
        user.tecRelationship.map(relationship =>
          accumulate(relationship, acc)
        );
      }
      else {
        accumulate("No especificado", acc);
      }
    });

    return acc;
  }, {"No especificado": 0});

  const data = Object.keys(relationships).map(relationship => {
    return { type: relationship, value: relationships[relationship] };
  });

  return (
    <Pie
      angleField="value"
      colorField="type"
      meta={{
        type: {
          alias: "Relación",
          formatter: v => {
            return getReadableValue("TEC_RELATIONSHIP_TYPES", v, v);
          }
        }
      }}
      label={{
        type: "inner",
        offset: "-30%",
        content: function content(_ref) {
          const percent = _ref.percent;
          return "".concat((percent * 100).toFixed(2), "%");
        },
        style: {
          fontSize: 14,
          textAlign: "center"
        }
      }}
      data={data} />
  );
}
